import { render } from "./bid_akutansi.vue?vue&type=template&id=86dae5d6"
import script from "./bid_akutansi.vue?vue&type=script&lang=js"
export * from "./bid_akutansi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__